module.exports = __webpack_public_path__ + "fonts/Roboto-LightItalic.d1efcd4d.ttf";